import { makeAutoObservable } from "mobx";
import { NodeInterface } from "../../../tables/schemas/nodes";
import { CalcPageTabs } from "../../CalculationsPage";
import { ParamType, VectorTypeEnum } from "../../enums";



const LocalStorageKey = "calcFilters";
class FiltersStore {
    private projectId: number | null = null;
    private selectedNode: number | null = null;
    private scType: number = 1;
    private tab: number = 1;
    private locationOfDamageFilterString: string = "";

    // Фильтр колонок в расчетной таблице узлов
    private nodeValueTypes: string[] = [];

    // Фильтр колонок в расчетной таблице ветвей
    private branchValueTypes: string[] = [];

    // Фильтр колонок в расчетной таблице параметров повреждений
    private damageParamsValueTypes: string[] = [];

    private _nodes: NodeInterface[] = [];

    constructor() {
        makeAutoObservable(this);
        const strData: string = localStorage.getItem(LocalStorageKey) || JSON.stringify({});
        const data = JSON.parse(strData);
        this.projectId = data.projectId || null;
        this.tab = data.tab || CalcPageTabs.Nodes;
        this.scType = data.scType || 1;
        this.selectedNode = data.selectedNode || null;
        this.nodeValueTypes = data.nodeValueTypes || [
            VectorTypeEnum.Phase.name,
            VectorTypeEnum.Linear.name,
            VectorTypeEnum.Sequence.name,
        ];
        this.branchValueTypes = data.branchValueTypes || [ParamType.Current.name, ParamType.Power.name, ParamType.Resistance.name];
        this.damageParamsValueTypes = data.damageParamsValueTypes || [ParamType.Current.name, ParamType.Resistance.name];
        this.locationOfDamageFilterString = data.locationOfDamageFilterString || "";
    }

    get getLocationOfDamageFilterString(): string {
        return this.locationOfDamageFilterString;
    }
    setLocationOfDamageFilterString(newFilterString: string): void {
        this.locationOfDamageFilterString = newFilterString;
        this.saveData();
    }

    get getProjectId(): number | null {
        return this.projectId;
    }
    setProjectId(projectId: number): void {
        this.projectId = projectId;
        this.saveData();
    }

    get getTab(): number {
        return this.tab;
    }
    get getScType(): number {
        return this.scType;
    }
    get getSelectedNode(): number | null {
        return this.selectedNode;
    }
    setTab(tab: number): void {
        this.tab = tab;
        this.saveData();
    }
    setScType(scType: number): void {
        this.scType = scType;
        this.saveData();
    }
    setSelectedNode(selectedNode: number | null): void {
        this.selectedNode = selectedNode;
        this.saveData();
    }
    get getNodeValueTypes(): string[] {
        return this.nodeValueTypes;
    }
    setNodeValueTypes(nodeValueTypes: string[]): void {
        this.nodeValueTypes = nodeValueTypes;
        this.saveData();
    }

    get getBranchValueTypes(): string[] {
        return this.branchValueTypes;
    }
    setBranchValueTypes(branchValueTypes: string[]): void {
        this.branchValueTypes = branchValueTypes;
        this.saveData();
    }

    get getDamageParamsValueTypes(): string[] {
        return this.damageParamsValueTypes;
    }
    setDamageParamsValueTypes(damageParamsValueTypes: string[]): void {
        this.damageParamsValueTypes = damageParamsValueTypes;
        this.saveData();
    }

    _setNodes(nodes: NodeInterface[]): void {
        this._nodes = nodes;
    }
    get getNodes(): NodeInterface[] {
        return this._nodes;
    }
    get getSelectedNodeName(): string {
        return this._nodes.find(node => node.id === this.selectedNode)?.name || "";
    }
    delete(): void {
        localStorage.removeItem(LocalStorageKey);
    }

    saveData() {
        localStorage.setItem(
            LocalStorageKey,
            JSON.stringify({
                tab: this.tab,
                scType: this.scType,
                selectedNode: this.selectedNode,
                nodeValueTypes: this.nodeValueTypes,
                branchValueTypes: this.branchValueTypes,
                damageParamsValueTypes: this.damageParamsValueTypes,
                locationOfDamageFilterString: this.locationOfDamageFilterString,
                projectId: this.projectId,
            })
        );
    }
}


const filterStore = new FiltersStore();
export default filterStore;
